import * as types from './actionTypes';
import client from 'helpers/client';
import cognito from 'helpers/cognito';
import Auth from '@aws-amplify/auth';
import paths from 'redux/paths';
import utils from 'helpers/utils';
import Utils from '../../helpers/utils';
import moment from 'moment';

const _utmTracking = async (user) => {
  const utmParams = JSON.parse(localStorage.getItem('ced:utmParams'));
  if (!utmParams) return;
  utmParams.email = user.email;
  try {
    const data = await client.sendRequest({
      path: paths.SAVE_UTM_TRACKING,
      method: 'POST',
      params: utmParams,
      headers: await cognito.getHeaderAuthorization(),
    });
    localStorage.removeItem('ced:utmParams');
    return data;
  } catch (error) {
    console.log('[_utmTracking]', error);
  }
};

export const fetchUser = (callback) => {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_USER });

    // To sure get currentUserCredentials correct on production environment when changing between minisites, we need to call twice
    let cred = await Auth.currentUserCredentials();
    cred = await Auth.currentUserCredentials();

    if (!cred || !cred.authenticated)
      return dispatch({
        type: types.FETCH_USER_FAILED,
        reason: 'Empty credential.',
      });

    const { authenticated, data } = cred;
    client
      .api('/user', 'get', { headers: await cognito.getHeaderAuthorization() })
      .then((res) => {
        const user = res.data.data;
        dispatch({
          type: types.FETCH_USER_SUCCESS,
          payload: {
            ...user,
            authenticated,
            credentials: data.Credentials,
          },
        });
        _utmTracking(user);
        callback && callback(user);
      })
      .catch((err) => {
        dispatch({
          type: types.FETCH_USER_FAILED,
          reason: err.message,
        });
      });
  };
};

export const fetchCodesOfUser =
  ({ page = 1, limit = 10 }) =>
    async (dispatch) => {
      try {
        dispatch({ type: types.FETCH_CODES_OF_USER });
        const { data: payload } = await client.sendRequest({
          path: `${paths.GET_TOKEN_PORTAL}?page=${page}&limit=${limit}`,
          method: 'GET',
          headers: await cognito.getHeaderAuthorization(),
        });
        dispatch({ type: types.FETCH_CODES_OF_USER_SUCCESS, payload });
        return payload;
      } catch (err) {
        dispatch({ type: types.FETCH_CODES_OF_USER_FAILED, reason: err.message });
      }
    };

export const setEditting = (value) => {
  return (dispatch) => {
    dispatch({
      type: types.SET_EDITTING,
      payload: value,
    });
  };
};

export const updateUserInfo = (options = {}, callback) => {
  console.log('updateUserInfo called with options:', options);
  return async (dispatch) => {
    dispatch({
      type: types.UPDATE_USER,
    });

    try {
      const userData = localStorage.getItem('ced:user-info');
      const userStorage = userData ? JSON.parse(userData) : null;
      if (!userStorage) {
        localStorage.removeItem('ced:user-info');
        return dispatch({
          type: types.FETCH_USER_FAILED,
          reason: 'Empty credential.',
        });
      }
      console.log('User Storage:', userStorage);
      const headers = { 'authorization': userStorage.accessToken };
      console.log('Headers:', headers);

      // Thêm userStorage._id vào options (sử dụng _id từ localStorage)
      // Nếu _id không có, thử sử dụng cedUserId
      const userId = userStorage._id && userStorage._id !== '' ? userStorage._id : userStorage.cedUserId;
      if (userId && userId !== '') {
        options.userId = userId;
        console.log('Sending userId to API:', userId);
      } else {
        console.log('No valid userId found in userStorage, API will find user by email');
        // Remove userId from options if it's empty
        delete options.userId;
      }
      console.log('Full userStorage:', userStorage);
      console.log('About to call API with:', {
        path: '/mvp/buddy-update-profile-full',
        method: 'POST',
        params: options,
        headers: headers,
      });

      const res = await client.sendRequest({
        path: '/mvp/buddy-update-profile-full',
        method: 'POST',
        params: options,
        headers: headers,
      });
      console.log('API Response:', res);

      dispatch({
        type: types.UPDATE_USER_SUCCESS,
        payload: res.data.data,
      });

      if (callback) {
        callback(res);
      }
    } catch (err) {
      console.error('API Error:', err);
      console.error('Error details:', {
        message: err.message,
        stack: err.stack,
        response: err.response,
        status: err.status
      });

      dispatch({
        type: types.UPDATE_USER_FAILED,
        reason: err.message,
      });

      // Call callback with error
      if (callback) {
        callback({ status: 'ERROR', message: err.message });
      }
    }
  };
};
export const getUserProfileMvp = () => async (dispatch) => {
  try {
    const userData = localStorage.getItem('ced:user-info');
    const userStorage = userData ? JSON.parse(userData) : null;
    if (!userStorage) {
      localStorage.removeItem('ced:user-info');
      dispatch({
        type: types.FETCH_USER_FAILED,
        reason: 'Empty credential.',
      });
      return null;
    }

    // Check if user has valid _id before making API call
    if (!userStorage._id) {
      console.log('User _id is undefined, cannot fetch profile');
      dispatch({
        type: types.FETCH_USER_FAILED,
        reason: 'User ID is undefined',
      });
      return null;
    }

    console.log('User Storage:', userStorage);
    const headers = { 'authorization': userStorage.accessToken };
    console.log('Headers:', headers);

    const res = await client.sendRequest({
      path: `/mvp/buddy-profile/${userStorage._id}`,
      method: 'GET',
      headers: headers,
    });

    console.log('API Response:', res);

    // Xử lý phoneNumber để đảm bảo là string
    let profileData = res.data;
    // Ensure favouriteTopics is included
    if (profileData && !profileData.favouriteTopics) {
      profileData.favouriteTopics = [];
    }
    // Ensure sharingTopics is included
    if (profileData && !profileData.sharingTopics) {
      profileData.sharingTopics = [];
    }
    if (profileData && profileData.phoneNumber) {
      let phoneNumber = profileData.phoneNumber;
      // Nếu phoneNumber là object (có thể có dialCode và number)
      if (typeof phoneNumber === 'object' && phoneNumber !== null) {
        if (phoneNumber.number) {
          // Nếu có dialCode, kết hợp dialCode + number
          phoneNumber = phoneNumber.dialCode ? `${phoneNumber.dialCode}${phoneNumber.number}` : phoneNumber.number;
        } else {
          // Nếu là object nhưng không có number, chuyển thành string rỗng
          phoneNumber = '';
        }
      }
      // Nếu phoneNumber là string, giữ nguyên
      else if (typeof phoneNumber === 'string') {
        phoneNumber = phoneNumber;
      }
      // Các trường hợp khác, chuyển thành string
      else {
        phoneNumber = String(phoneNumber);
      }
      profileData = { ...profileData, phoneNumber };
    }

    dispatch({
      type: types.FETCH_USER_SUCCESS,
      payload: profileData,
    });
    return profileData;
  } catch (err) {
    console.error('API Error:', err);
    dispatch({
      type: types.FETCH_USER_FAILED,
      reason: err.message,
    });
    return null;
  }
};


export const updateUserInfoBasic = (options = {}, callback) => {
  return async (dispatch) => {
    dispatch({
      type: types.UPDATE_USER,
    });
    client
      .api(paths.UPDATE_USER_BASIC, 'post', options, { headers: await cognito.getHeaderAuthorization() })
      .then((res) => {
        dispatch({
          type: types.UPDATE_USER_SUCCESS,
          payload: res.data.data,
        });
        callback && callback(res);
      })
      .catch((err) =>
        dispatch({
          type: types.UPDATE_USER_FAILED,
          reason: err.message,
        }),
      );
  };
};

export const updateProfilePicture = (pictureUri) => async (dispatch) => {
  try {
    dispatch({ type: types.UPDATE_PROFILE_PICTURE });
    const { data = {} } = await client.sendRequest({
      path: paths.UPDATE_PROFILE_PICTURE,
      method: 'POST',
      params: { avatarUrl: pictureUri },
      headers: await cognito.getHeaderAuthorization(),
    });
    dispatch({
      type: types.UPDATE_PROFILE_PICTURE_SUCCESS,
      avatarUrl: data.avatarUrl,
    });
  } catch (err) {
    dispatch({
      type: types.UPDATE_PROFILE_PICTURE_FAILED,
      reason: err.message,
    });
  }
};

export const updateKATAddress = (katAddress, callback) => {
  return async (dispatch) => {
    dispatch({
      type: types.UPDATE_KAT_ADDRESS,
    });

    client
      .api(
        '/user/update-kat-address',
        'post',
        { katAddress: katAddress },
        { headers: await cognito.getHeaderAuthorization() },
      )
      .then((res) => {
        dispatch({
          type: types.UPDATE_KAT_ADDRESS_SUCCESS,
          payload: res.data.data,
        });
        callback && callback(res);
      })
      .catch((err) =>
        dispatch({
          type: types.UPDATE_KAT_ADDRESS_FAILED,
          reason: err.message,
        }),
      );
  };
};

export const uploadImage = (data, callback) => {
  return async (dispatch) => {
    dispatch({ type: types.UPLOAD_IMAGE });

    client
      .api('/image/upload', 'post', data, { headers: await cognito.getHeaderAuthorization() })
      .then(function (res) {
        const imageUrl = res.data.data.imageLink;
        dispatch({
          type: types.UPLOAD_IMAGE_SUCCESS,
          payload: imageUrl,
        });
        callback && callback(null, imageUrl);
      })
      .catch((err) => {
        dispatch({
          type: types.UPLOAD_IMAGE_FAILED,
        });
        callback && callback(err);
      });
  };
};

export const linkProvider = (headers, callback) => {
  return async (dispatch) => {
    client
      .api('/cognito/link-provider', 'post', null, { headers: headers })
      .then(function (res) {
        callback && callback(null);
      })
      .catch((err) => {
        callback && callback(err);
      });
  };
};

export const fetchAllReferences = () => async (dispatch, getState) => {
  try {
    dispatch({ type: types.FETCH_ALL_REFERENCES });

    const { references } = getState().user;
    const fileNames = [
      'collaborativeTools',
      'databases',
      'languages',
      'miscTools',
      'os',
      'platforms',
      'webFrameworks',
      'schools',
      'majors',
      'organizations',
      'roles',
    ];

    const getPromises = fileNames
      .filter((fileName) => !references[fileName])
      .map((fileName) => {
        return new Promise((resolve, reject) => {
          client
            .api(
              `https://kambria-static.s3-ap-southeast-1.amazonaws.com/userprofile/references/${fileName}.json`,
              'GET',
            )
            .then(({ data }) => {
              data = data.map((value) => ({ label: value, value }));
              dispatch({
                type: types.UPDATE_REFERENCE,
                payload: { [fileName]: data },
              });
              resolve();
            })
            .catch(reject);
        });
      });
    await Promise.all(getPromises);
    // type technology category fix cung du lieu tam thoi
    const technologyCategory = [
      { label: 'AI', value: 'AI' },
      { label: 'Robotics', value: 'Robotics' },
      { label: 'Blockchain', value: 'Blockchain' },
      { label: 'IoT', value: 'IoT' }
    ]
    const fileNameTechnologyCategory = 'technologyCategory'
    await dispatch({
      type: types.UPDATE_REFERENCE,
      payload: { [fileNameTechnologyCategory]: technologyCategory },
    });
    dispatch({ type: types.FETCH_ALL_REFERENCES_SUCCESS });
  } catch (err) {
    dispatch({ type: types.FETCH_ALL_REFERENCES_FAILED, error: err.message });
  }
};

export const checkPublicUsername = (publicUsername) => async (dispatch) => {
  try {
    dispatch({ type: types.CHECK_PUBLIC_USERNAME });
    const data = await client.sendRequest({
      path: paths.CHECK_PUBLIC_USERNAME,
      method: 'POST',
      params: { publicUsername },
      headers: await cognito.getHeaderAuthorization(),
    });
    dispatch({ type: types.CHECK_PUBLIC_USERNAME_SUCCESS, payload: data });
    return data;
  } catch (err) {
    dispatch({ type: types.CHECK_PUBLIC_USERNAME_FAILED, error: err.message });
  }
};

export const checkAWSUser = (email) => async () => {
  try {
    console.log("email", email)
    const data = await client.sendRequest({
      path: paths.CHECK_AWS_USERNAME,
      method: 'POST',
      params: { email }
    });
    return data;
  } catch (err) {
    return null;
  }
};

export const updateEmailToSendy = (email) => async () => {
  try {
    const data = await client.sendRequest({
      path: paths.SUBSCRIBE_SENDY,
      method: 'POST',
      params: { email },
      //headers: await cognito.getHeaderAuthorization(),
    });
    return data;
  } catch (err) {
    return null;
  }
}


export const mvpRefreshToken = () => async (dispatch) => {
  try {
    const refreshToken = await utils.getCookie('_RFT')
    if (!refreshToken) {
      return null
    }
    const headers = { 'authorization': refreshToken };
    const data = await client.sendRequest({
      path: `/mvp/refresh-token`,
      method: 'POST',
      headers: headers,
    });

    if (data.status == 'OK') {
      const user = {
        statusVerify: data.user.statusVerify,
        type: data.user.type,
        name: data.user.name,
        _id: data.user._id,
        accessToken: data.accessToken
      }

      dispatch({
        type: types.FETCH_USER_SUCCESS,
        payload: {
          ...user,
          authenticated: true,
          credentials: data.Credentials,
          token: data.accessToken,
        },
      });

      localStorage.setItem('ced:user-info', JSON.stringify(user));
      utils.saveToCookie('_RFT', data.refreshToken, 365)
      const redirectTo = sessionStorage.getItem('ced:previousUrl') || '/';
      sessionStorage.removeItem('ced:previousUrl');
      window.location.href = redirectTo;
    }

    return null
  } catch (err) {
    return { status: 'not-ok', message: err.message }
  }
};

export const verifyBySignIn = (email, password) => async (dispatch) => {
  try {
    // Ensure email is lowercase and trimmed
    const normalizedEmail = email ? email.toLowerCase().trim() : email;

    const result = await client.sendRequest({
      path: paths.MVP_LOGIN,
      method: 'POST',
      params: { email: normalizedEmail, password },
    });

    return result;
  } catch (err) {
    return { status: 'not-ok', message: err.message }
  }
}

export const changePassword = (email, password, password2) => async (dispatch) => {
  try {
    const data = await client.sendRequest({
      path: paths.CHANGE_PASSWORD,
      method: 'POST',
      params: { email, password, password2 },
    })
    if (data.status === 'OK') {
      const user = {
        name: data.user.name,
        _id: data.user._id,
        accessToken: data.accessToken
      }

      dispatch({
        type: types.FETCH_USER_SUCCESS,
        payload: {
          ...user,
          authenticated: true,
          credentials: data?.Credentials,
          token: data.accessToken,
        },
      });
    }
    return data
  } catch (err) {
    return { status: 'not-ok', message: err.message }
  }
}

export const logInMvp = (email, password) => async (dispatch) => {
  try {
    dispatch({ type: types.FETCH_USER });
    const data = await client.sendRequest({
      path: paths.MVP_LOGIN,
      method: 'POST',
      params: { email, password },
    })
    if (data.status == 'OK') {
      const user = {
        name: data.user.name,
        _id: data.user._id,
        accessToken: data.accessToken
      }

      dispatch({
        type: types.FETCH_USER_SUCCESS,
        payload: {
          ...user,
          authenticated: true,
          credentials: data.Credentials,
          token: data.accessToken,
        },
      });
    }
    return data;
  } catch (err) {

    return { status: 'not-ok', message: err.message }
  }
}

export const getListLanguage = () => async (dispatch, getState) => {
  try {
    const { accessToken } = getState().user;
    const response = await client.sendRequest({
      path: paths.LIST_LANGUAGE,
      method: 'GET',
      // headers: { 'authorization': accessToken }
    })
    let data = null;
    if (response.status === 'OK') {
      data = response.data

      dispatch({
        type: types.MVP_GET_LIST_LANGUAGE,
        data
      });
    }
    return data;
  } catch (err) {
    return { status: 'not-ok', message: err.message }
  }
}

export const changeLanguage = (language) => async (dispatch, getState) => {
  if (!language) {
    return { status: 'not-ok', message: 'Language is required' }
  }
  try {
    const user = getState().user;
    if (!user || !user.accessToken) {
      return { status: 'not-ok', message: 'User not authenticated' }
    }
    
    const response = await client.sendRequest({
      path: paths.CHANGE_LANGUAGE,
      method: 'POST',
      params: { language },
      headers: { 'authorization': user.accessToken }
    })

    // Check if response has status field and handle both 'OK' and 'ERROR' cases
    if (response && response.status === 'OK') {
      // Sau khi lưu thành công, fetch lại user từ API để lấy ngôn ngữ mới từ database
      let userData;
      try {
        userData = localStorage.getItem('ced:user-info');
      } catch (e) {
        userData = null;
      }
      const userStorage = userData ? JSON.parse(userData) : null;
      
      // Only fetch updated user if localStorage has user info (don't use fallback from getState)
      if (userStorage && userStorage.accessToken) {
        try {
          // Fetch lại user từ API để lấy ngôn ngữ mới
          const userResponse = await client.sendRequest({
            path: '/mvp/me',
            method: 'POST',
            params: {},
            headers: { 'authorization': userStorage.accessToken }
          });

          if (userResponse && userResponse.status === 'OK' && userResponse.user) {
            // Xử lý dateOfBirth
            let dateOfBirth = userResponse.user.dateOfBirth;
            if (dateOfBirth) {
              if (dateOfBirth instanceof Date) {
                dateOfBirth = moment(dateOfBirth).format('YYYY-MM-DD');
              } else if (moment.isMoment(dateOfBirth)) {
                dateOfBirth = dateOfBirth.format('YYYY-MM-DD');
              } else if (typeof dateOfBirth === 'string') {
                const parsedDate = moment(dateOfBirth);
                if (parsedDate.isValid()) {
                  dateOfBirth = parsedDate.format('YYYY-MM-DD');
                }
              }
            }

            // Xử lý phoneNumber
            let phoneNumber = userResponse.user.phoneNumber;
            if (phoneNumber) {
              if (typeof phoneNumber === 'object' && phoneNumber !== null) {
                if (phoneNumber.number) {
                  phoneNumber = phoneNumber.dialCode ? `${phoneNumber.dialCode}${phoneNumber.number}` : phoneNumber.number;
                } else {
                  phoneNumber = '';
                }
              } else if (typeof phoneNumber === 'string') {
                phoneNumber = phoneNumber;
              } else {
                phoneNumber = String(phoneNumber);
              }
            } else {
              phoneNumber = '';
            }

            // Cập nhật user object với ngôn ngữ mới từ API
            const updatedUser = {
              name: userResponse.user.name,
              email: userResponse.user.email,
              walletAddress: userResponse.user.walletAddress,
              _id: userResponse.user._id || userResponse.user.id,
              cedUserId: userResponse.user.cedUserId,
              accessToken: userStorage.accessToken,
              type: userResponse.user.mvpUserType,
              mvpUserType: userResponse.user.mvpUserType,
              language: userResponse.user.language, // Ngôn ngữ mới từ API (format {value, label})
              statusVerify: userResponse.user.statusVerify,
              firstName: userResponse.user.firstName,
              dateOfBirth: dateOfBirth || undefined,
              phoneNumber: phoneNumber,
              youthCommunity: userResponse.user.youthCommunity || null,
              favouriteTopics: userResponse.user.favouriteTopics || []
            };

            // Cập nhật localStorage
            localStorage.setItem('ced:user-info', JSON.stringify(updatedUser));

            // Cập nhật Redux state với user mới (bao gồm ngôn ngữ mới)
            dispatch({
              type: types.FETCH_USER_SUCCESS,
              payload: {
                ...updatedUser,
                authenticated: true,
                credentials: userResponse.Credentials,
                accessToken: userStorage.accessToken,
                wallet: userResponse.user.wallet,
              },
            });
          }
        } catch (fetchError) {
          console.error('Error fetching updated user:', fetchError);
          // Nếu không fetch được, vẫn cập nhật với ngôn ngữ đã chọn
          try {
            const fallbackUserData = localStorage.getItem('ced:user-info');
            if (fallbackUserData) {
              try {
                const userInfo = JSON.parse(fallbackUserData);
                const mvp = getState().mvp;
                let languageObj = null;
                if (mvp && mvp.listLanguage && Array.isArray(mvp.listLanguage)) {
                  languageObj = mvp.listLanguage.find(lg => lg.value === language);
                }
                if (!languageObj) {
                  languageObj = {
                    value: language,
                    label: language === 'en' ? 'English' : 'Tiếng Việt'
                  };
                }
                userInfo.language = languageObj;
                localStorage.setItem('ced:user-info', JSON.stringify(userInfo));
                
                // Get current user from state for the dispatch
                const currentUser = getState().user;
                dispatch({
                  type: types.FETCH_USER_SUCCESS,
                  payload: {
                    ...currentUser,
                    language: languageObj,
                  },
                });
              } catch (error) {
                console.error('Error updating user info in localStorage:', error);
              }
            }
          } catch (error) {
            // If there's an error accessing localStorage or getState, just log it
            // Don't let it prevent returning 'ok' since changeLanguage succeeded
            console.error('Error in fallback handler:', error);
          }
        }
      }
      
      // Update localStorage for API calls
      localStorage.setItem('ced:language', language);
      
      return { status: 'ok', message: response.message || 'Language updated successfully' }
    } else {
      // Handle error response or non-OK status
      return { status: 'not-ok', message: (response && response.message) ? response.message : 'Failed to update language' }
    }
  } catch (err) {
    console.error('Error changing language:', err);
    return { status: 'not-ok', message: err.message || 'Failed to update language' }
  }
}

export const fetchUserMvp = (callback) => {
  return async (dispatch) => {
    // Check if already fetching to prevent multiple calls
    const isFetching = localStorage.getItem('ced:fetching-user');
    if (isFetching === 'true') {
      console.log('User data is already being fetched, skipping...');
      return;
    }

    dispatch({ type: types.FETCH_USER });
    localStorage.setItem('ced:fetching-user', 'true');

    const userData = localStorage.getItem('ced:user-info')
    const userStorage = userData ? JSON.parse(userData) : null;
    if (!userStorage) {
      localStorage.removeItem('ced:user-info')
      localStorage.removeItem('ced:fetching-user');
      return dispatch({
        type: types.FETCH_USER_FAILED,
        reason: 'Empty credential.',
      });
    }

    client.sendRequest({
      path: '/mvp/me',
      method: 'POST',
      params: {},
      headers: { 'authorization': userStorage.accessToken },
    }).then((data) => {
      if (data.status == 'OK') {
        // Xử lý dateOfBirth để đảm bảo format đúng
        let dateOfBirth = data.user.dateOfBirth;
        if (dateOfBirth) {
          // Nếu dateOfBirth là Date object, chuyển thành string YYYY-MM-DD
          if (dateOfBirth instanceof Date) {
            dateOfBirth = moment(dateOfBirth).format('YYYY-MM-DD');
          }
          // Nếu dateOfBirth là moment object, chuyển thành string
          else if (moment.isMoment(dateOfBirth)) {
            dateOfBirth = dateOfBirth.format('YYYY-MM-DD');
          }
          // Nếu dateOfBirth là string, đảm bảo format đúng
          else if (typeof dateOfBirth === 'string') {
            const parsedDate = moment(dateOfBirth);
            if (parsedDate.isValid()) {
              dateOfBirth = parsedDate.format('YYYY-MM-DD');
            }
          }
}

        // Xử lý phoneNumber để đảm bảo là string
        let phoneNumber = data.user.phoneNumber;
        if (phoneNumber) {
          // Nếu phoneNumber là object (có thể có dialCode và number)
          if (typeof phoneNumber === 'object' && phoneNumber !== null) {
            if (phoneNumber.number) {
              // Nếu có dialCode, kết hợp dialCode + number
              phoneNumber = phoneNumber.dialCode ? `${phoneNumber.dialCode}${phoneNumber.number}` : phoneNumber.number;
            } else {
              // Nếu là object nhưng không có number, chuyển thành string rỗng
              phoneNumber = '';
            }
          }
          // Nếu phoneNumber là string, giữ nguyên
          else if (typeof phoneNumber === 'string') {
            phoneNumber = phoneNumber;
          }
          // Các trường hợp khác, chuyển thành string
          else {
            phoneNumber = String(phoneNumber);
          }
        } else {
          phoneNumber = '';
        }

        const user = {
          name: data.user.name,
          email: data.user.email,
          walletAddress: data.user.walletAddress,
          _id: data.user._id || data.user.id, // Try both _id and id
          cedUserId: data.user.cedUserId,
          accessToken: userStorage.accessToken,
          type: data.user.mvpUserType,
          mvpUserType: data.user.mvpUserType, // MVP user type (explorer/guide/both)
          language: data.user.language,
          statusVerify: data.user.statusVerify,
          firstName: data.user.firstName,
          dateOfBirth: dateOfBirth,
          phoneNumber: phoneNumber,
          youthCommunity: data.user.youthCommunity || null, // Include youthCommunity in user object
          favouriteTopics: data.user.favouriteTopics || [], // Include favouriteTopics
          sharingTopics: data.user.sharingTopics || [] // Include sharingTopics
        }

        dispatch({
          type: types.FETCH_USER_SUCCESS,
          payload: {
            ...user,
            authenticated: true,
            credentials: data.Credentials,
            accessToken: userStorage.accessToken,
            wallet: data.user.wallet,
          },
        });
        localStorage.setItem('ced:user-info', JSON.stringify(user))
        localStorage.removeItem('ced:fetching-user');
        callback && callback(user);
      }
    })
      .catch((err) => {
        localStorage.removeItem('ced:fetching-user');
        dispatch({
          type: types.FETCH_USER_FAILED,
          reason: err.message,
        });
        callback && callback(null);
      });
  };
};

export const logOutMvp = (accessToken) => async (dispatch) => {
  try {
    dispatch({ type: types.FETCH_USER });
    Utils.removeCookie('_RFT')
    const data = await client.sendRequest({
      path: 'mvp/sign-out',
      method: 'POST',
      params: {},
      headers: { 'authorization': accessToken },
    })
    if (data.status == 'OK') {
      dispatch({
        type: types.FETCH_USER_SUCCESS,
        payload: {
          user: null,
          authenticated: false,
          credentials: null,
          token: null
        },
      });
    }
    return data;
  } catch (err) {
    return null
  }
}

export const getBuddyYouthCommunity = (options = {}) => async () => {
  try {
    const params = (options.forSignup || options.skipNA) ? { forSignup: 'true' } : {}
    const data = await client.sendRequest({
      path: paths.LIST_YOUTH_COMMUNITY,
      method: 'GET',
      params,
    })
    if (data.status !== 'OK') {
      return null
    }
    return data.data
  } catch (e) {
    return null
  }
}

export const getActiveCode = (email, password, type, name, giftCode, youthCommunity = null) => async () => {
  // console.log('🔍 [DEBUG] getActiveCode called with:', { email, password, type, name, giftCode, youthCommunity });
  try {
    const params = { email, password, type, name, giftCode };
    if (youthCommunity !== null && youthCommunity !== undefined && youthCommunity !== '') {
      params.youthCommunity = youthCommunity;
    }
    const data = await client.sendRequest({
      path: paths.GET_ACTIVE_CODE,
      method: 'POST',
      params,
    })
    // console.log('🔍 [DEBUG] getActiveCode response:', data);
    return data
  } catch (err) {
    // console.log('❌ [DEBUG] getActiveCode error:', err);
    return { status: 'ERROR', message: err.message, type: err?.type }
  }
}

export const mvpSignUp = (params) => async (dispatch) => {
  // console.log('🔍 [DEBUG] mvpSignUp called with:', params);
  try {
    const data = await client.sendRequest({
      path: paths.SIGN_UP,
      method: 'POST',
      params: params
    })
    // console.log('🔍 [DEBUG] mvpSignUp response:', data);
    if (data.status === 'OK') {
      const user = {
        name: data.user.name,
        _id: data.user._id,
        accessToken: data.accessToken
      }
      // console.log('🔍 [DEBUG] Dispatching user success:', user);
      dispatch({
        type: types.FETCH_USER_SUCCESS,
        payload: {
          ...data.user,
          authenticated: true,
          token: data.accessToken,
        },
      });
    }
    return data
  } catch (err) {
    // console.log('❌ [DEBUG] mvpSignUp error:', err);
    return {
      status: 'ERROR',
      message: err.message || 'Đã xảy ra lỗi',
      type: err.type || undefined
    }
  }
}

// Forgot Password Actions
export const sendForgotPasswordCode = (email) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.SEND_FORGOT_PASSWORD_CODE });
      const { data } = await client.sendRequest({
        path: '/mvp/otp-with-forget-password',
        method: 'POST',
        params: { email },
      });
      dispatch({ type: types.SEND_FORGOT_PASSWORD_CODE_SUCCESS, payload: data });
      return data;
    } catch (err) {
      dispatch({ type: types.SEND_FORGOT_PASSWORD_CODE_FAILED, reason: err.message });
      throw err;
    }
  };
};

export const verifyForgotPasswordCode = (email, code) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.VERIFY_FORGOT_PASSWORD_CODE });
      const { data } = await client.sendRequest({
        path: '/mvp/verify-otp-with-forget-password',
        method: 'POST',
        params: { email, active_code: code },
      });
      dispatch({ type: types.VERIFY_FORGOT_PASSWORD_CODE_SUCCESS, payload: data });
      return data;
    } catch (err) {
      dispatch({ type: types.VERIFY_FORGOT_PASSWORD_CODE_FAILED, reason: err.message });
      throw err;
    }
  };
};

export const resetPassword = (email, password, password2, token = null) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.RESET_PASSWORD });
      const endpoint = token ? '/mvp/reset-password-with-token' : '/mvp/change-password';
      const params = token
        ? { email, password, password2, token }
        : { email, password, password2 };

      const { data } = await client.sendRequest({
        path: endpoint,
        method: 'POST',
        params,
      });
      dispatch({ type: types.RESET_PASSWORD_SUCCESS, payload: data });
      return data;
    } catch (err) {
      dispatch({ type: types.RESET_PASSWORD_FAILED, reason: err.message });
      throw err;
    }
  };
};

export const updateMvpUserType = (mvpUserType, youthCommunity = null) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.UPDATE_USER });

      const userData = localStorage.getItem('ced:user-info');
      const userStorage = userData ? JSON.parse(userData) : null;

      if (!userStorage || !userStorage.accessToken) {
        throw new Error('User not authenticated');
      }

      const params = {
        email: userStorage.email,
        mvpUserType,
      };

      if (youthCommunity !== null && youthCommunity !== undefined) {
        params.youthCommunity = youthCommunity;
      }

      const data = await client.sendRequest({
        path: '/mvp/update-user-type',
        method: 'POST',
        params,
        headers: {
          'authorization': userStorage.accessToken
        },
      });

      // Check if response has status field
      if (data && data.status === 'OK') {
        // Fetch updated user data
        await dispatch(fetchUserMvp());
        dispatch({ type: types.UPDATE_USER_SUCCESS });
        return data;
      } else if (data && data.status === 'ERROR') {
        // API returned error status
        const errorMessage = data.message || 'Failed to update user type';
        dispatch({ type: types.UPDATE_USER_FAILED, reason: errorMessage });
        throw new Error(errorMessage);
      } else {
        // Unexpected response format, but assume success if no error status
        await dispatch(fetchUserMvp());
        dispatch({ type: types.UPDATE_USER_SUCCESS });
        return data;
      }
    } catch (err) {
      // Handle network errors or API errors
      const errorMessage = err.message || err.data?.message || 'Failed to update user type';
      dispatch({ type: types.UPDATE_USER_FAILED, reason: errorMessage });
      throw new Error(errorMessage);
    }
  };
};
